import React from 'react';
import PropTypes from 'prop-types';

// MATERIAL_UI
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const SimpleHeader = (props) => {
  if (!props) {
    return null;
  }

  const { title, appName, module } = props;

  return (
    <Box
      sx={(theme) => ({
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
      })}
    >
      <AppBar position="static" enableColorOnDark>
        <Toolbar variant="dense">
          <img
            alt=""
            src={process.env.PUBLIC_URL + (module === 'EB' ? '/img/Heart.svg' : '/img/Factory.svg')}
            width="24px"
            height="24px"
          />
          <Typography
            variant="h1"
            sx={(theme) => ({
              flexGrow: 1,
              paddingLeft: theme.spacing(1),
              textTransform: 'none',
            })}
            noWrap
          >
            {appName}
          </Typography>
          <Typography
            variant="h1"
            sx={(theme) => ({
              paddingRight: theme.spacing(1),
              textTransform: 'none',
            })}
            noWrap
          >
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

SimpleHeader.defaultProps = {
  appName: 'Commercial Lines',
};

SimpleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  appName: PropTypes.string,
  module: PropTypes.string,
};

export default SimpleHeader;
